const scripts = require('./scripts')

function insertScript(content) {
    const s = document.createElement('script')
    s.innerHTML = content
    document.body.appendChild(s)
}

function install(id) {
    if (window.Beacon) return
    if (__DEBUG__) {
        if (! id) throw new Error('Beacon id required.')
    }
    insertScript(scripts.install())
    insertScript(scripts.initialize(id))
    if (__DEBUG__) {
        if (! window.Beacon) throw new Error('Beacon install failed.')
    }
}

if (__KARMA__) {
    // install mock Beacon for Karma tests
    window.Beacon = () => {}
}

module.exports = install
